import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

const RouteErrorBoundary = ({ children }) => {
  const location = useLocation();
  return (
    <ErrorBoundary resetKey={location.key}>
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
